import Fuse from "fuse.js";
import { MagnifyingGlassIcon } from "@heroicons/react/20/solid";

export default function RouteSearchInput({ setSearchString }) {
    return (
        <div className="flex flex-1 items-center justify-center">
            <div className="w-full">
                <label htmlFor="search" className="sr-only">
                    Taper pour rechercher
                </label>
                <div className="relative">
                    <div className="pointer-events-none absolute inset-y-0 left-0 flex items-center pl-3">
                        <MagnifyingGlassIcon
                            className="h-5 w-5 text-gray-400"
                            aria-hidden="true"
                        />
                    </div>
                    <input
                        autoComplete="off"
                        id="search"
                        name="search"
                        className="block w-full rounded-md border border-gray-300 bg-white py-2 pl-10 pr-3 leading-5 placeholder:text-gray-500 focus:border-orange-500 focus:outline-none focus:ring-1 focus:ring-orange-500 focus:placeholder:text-gray-400 sm:text-sm"
                        placeholder="Taper pour rechercher"
                        type="search"
                        onChange={(e) => {
                            setSearchString(e.target.value);
                        }}
                    />
                </div>
            </div>
        </div>
    );
}
